import { useCallback, useState } from "react";
// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";
import type { TenantHistoryAudit } from "../models/tenantHistoryAudit";

interface UseTenantHistoryAudit {
  audit: TenantHistoryAudit | null;
  isLoading: boolean;
  /** Lance l'analyse ; rejette en cas d'erreur API (à gérer à l'appel). */
  run: () => Promise<void>;
  reset: () => void;
}

/**
 * Analyse de l'historique de paiement d'un locataire. Chaque exécution coûte un
 * appel IA : elle est déclenchée explicitement via `run`, jamais en SWR.
 */
export default function useTenantHistoryAudit(
  tenantId: number | undefined,
): UseTenantHistoryAudit {
  const axios = useAuthenticatedAxios();
  const [audit, setAudit] = useState<TenantHistoryAudit | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const run = useCallback(async () => {
    if (!tenantId) return;
    setIsLoading(true);
    try {
      const res = await axios.post(`/tenants/${tenantId}/balances/audit`);
      setAudit(res.data as TenantHistoryAudit);
    } finally {
      setIsLoading(false);
    }
  }, [axios, tenantId]);

  const reset = useCallback(() => setAudit(null), []);

  return { audit, isLoading, run, reset };
}
